import type {IPluginRefOptions} from 'gatsby'
import type {PluginOptions as PrismicPreviewConfig} from 'gatsby-plugin-prismic-previews'
import type {PluginOptions as PrismicConfig} from 'gatsby-source-prismic'

import {linkResolver} from '../utils/link-resolver'

/**
 * The following list of options must be provided if set in both plugins. For
 * example, if a lang option is configured in gatsby-source-prismic, then that
 * option must also be provided to gatsby-plugin-prismic-previews:
 *
 * - graphQuery
 * - lang
 * - pageSize
 * - imageImgixParams
 * - imagePlaceholderImgixParams
 * - typePrefix
 */

// Need to specify the type of the `plugins` field to keep Ts happy
type PrismicConfigExtended = Partial<PrismicConfig> & {
    plugins: IPluginRefOptions['plugins']
}

const commonConfig: Partial<PrismicConfig> | Partial<PrismicPreviewConfig> = {
    repositoryName: 'commercial-helios',
    accessToken: process.env.PRISMIC_ACCESS_TOKEN,
    fetchLinks: ['slice_page.parent_document'],
}

/**
 * @see https://prismic.io/docs/technical-reference/gatsby-source-prismic
 */
export const prismicConfig: PrismicConfigExtended = {
    ...commonConfig,
    customTypesApiToken: process.env.PRISMIC_CUSTOM_TYPES_API_TOKEN,
    linkResolver,
    plugins: [],
}

/**
 * @see https://prismic.io/docs/technical-reference/gatsby-plugin-prismic-previews
 */
export const prismicPreviewConfig: Partial<PrismicPreviewConfig> = {
    ...commonConfig,
    toolbar: 'new',
    plugins: [],
}
